import { render, staticRenderFns } from "./EditOrderItemToggle.vue?vue&type=template&id=1956a86c&scoped=true"
import script from "./EditOrderItemToggle.vue?vue&type=script&lang=js"
export * from "./EditOrderItemToggle.vue?vue&type=script&lang=js"
import style0 from "./EditOrderItemToggle.vue?vue&type=style&index=0&id=1956a86c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1956a86c",
  null
  
)

export default component.exports